<template>
  <FullScreenPopup
    ref="popup"
    :closeable="isSuccessStep"
    title="ОСЦПВ заявлено"
    @visibility-change="onVisibilityChange"
  >
    <div class="declared-success">
      <Wizard
        ref="wizard"
        :steps="wizardSteps"
        :machine="machine"
        :context="context"
        :initial-step="initialStep"
      >
        <template #warning>
          <div class="declared-success__warning">
            <p class="declared-success__warning-title">Увага!</p>
            <p class="declared-success__warning-message">{{ warningCancelMessage }}</p>
          </div>
          <div class="declared-success__actions">
            <BlueButton class="declared-success__btn" @click="onAgree">Погоджуюсь</BlueButton>
          </div>
        </template>

        <template #success>
          <template v-if="policyLink">
            <p class="declared-success__subtitle">Перевірити його можна за посиланням нижче</p>
            <CopyInput :value="policyLink" placeholder="Посилання на поліс" />
          </template>
          <div class="declared-success__actions">
            <BlueButton class="declared-success__btn" @click="close">Закрити</BlueButton>
          </div>
        </template>
      </Wizard>
    </div>
  </FullScreenPopup>
</template>

<script>
import { StateMachine } from '@/shared/lib/state-machine';
import { BlueButton } from '@/shared/ui/form';
import { CopyInput } from '@/shared/ui/form/inputs';
import { FullScreenPopup } from '@/shared/ui/popup';
import { Wizard } from '@/shared/ui/wizard';

const STEPS = {
  WARNING: 'warning',
  SUCCESS: 'success',
};

export default {
  data() {
    return {
      policyLink: null,
      warningCancelMessage: null,
      context: {},
      machine: StateMachine({
        steps: [STEPS.WARNING, STEPS.SUCCESS],
        transitions: {
          [STEPS.WARNING]: [STEPS.SUCCESS],
          [STEPS.SUCCESS]: [],
        },
      }),
      wizardSteps: [
        { id: STEPS.WARNING },
        { id: STEPS.SUCCESS },
      ],
    };
  },
  computed: {
    initialStep() {
      return this.warningCancelMessage ? STEPS.WARNING : STEPS.SUCCESS;
    },
    isSuccessStep() {
      return this.$refs.wizard?.activeStepId === STEPS.SUCCESS;
    },
  },
  components: { FullScreenPopup, BlueButton, CopyInput, Wizard },
  methods: {
    open(policyLink, warningCancelMessage) {
      this.policyLink = policyLink;
      this.warningCancelMessage = warningCancelMessage || null;

      this.$nextTick(() => {
        this.$refs.popup.open();
      });
    },
    close() {
      this.$refs.popup?.close();
    },
    onAgree() {
      this.$refs.wizard?.next();
    },
    onVisibilityChange({ isVisible }) {
      if (!isVisible && this.isSuccessStep) {
        this.$emit('closed');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.declared-success {
  &__warning {
    margin-bottom: 16px;
  }

  &__warning-title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  &__warning-message {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }

  &__subtitle {
    font-size: 15px;
    margin-bottom: 16px;
  }

  &__actions {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }

  &__btn {
    width: 100%;
  }
}

::v-deep .fullscreen-popup__content-wrapper {
  max-width: 500px;
}
</style>
